import { GeoFenceCompanyOutput } from './geo-fence-company-output.model';
import { GeoFenceBranchOutput } from './geo-fence-branch-output.model';


export class GeoFenceOutputWithOutStatus implements IGeoFenceOutputWithOutStatus {
    /** The auto-generated id of the geofence master */
    geofence_id!: number;
    /** The company type should be All or Selected */
    company_type!: string;
    /** The branch type should be All or Selected */
    branch_type!: string;
    /** The place name with 255 character limit */
    name!: string;
    /** The description with 5000 character limit */
    description!: string;
    /** The tolerance of selected place */
    tolerance!: number;
    /** The geofence data */
    geofence_data!: string;
    /** The shapeData data */
    shape_data!: string;
    /** Selected category for geofence */
    category!: string;
    /** The flag for show geofence */
    show_geofence!: number;
    /** The consider for trip */
    consider_for_trip!: number;
    /** Fence type */
    fence_type!: string;
    /** The auto generated id from company details master */
    company_details_id!: number;
    /** The auto generated id from branch details master */
    branch_detail_id!: number;
    /** The color with 255 character limit */
    color!: string;
    selected_company_data!: GeoFenceCompanyOutput[];
    selected_branch_data!: GeoFenceBranchOutput[];
    status!: number;

    constructor(data?: IGeoFenceOutputWithOutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geofence_id = _data["geofence_id"];
            this.company_type = _data["company_type"];
            this.branch_type = _data["branch_type"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.tolerance = _data["tolerance"];
            this.geofence_data = _data["geofence_data"];
            this.shape_data = _data["shape_data"];
            this.category = _data["category"];
            this.show_geofence = _data["show_geofence"];
            this.consider_for_trip = _data["consider_for_trip"];
            this.fence_type = _data["fence_type"];
            this.company_details_id = _data["company_details_id"];
            this.branch_detail_id = _data["branch_detail_id"];
            this.color = _data["color"];
            if (Array.isArray(_data["selected_company_data"])) {
                this.selected_company_data = [] as any;
                for (let item of _data["selected_company_data"])
                    this.selected_company_data!.push(GeoFenceCompanyOutput.fromJS(item));
            }
            if (Array.isArray(_data["selected_branch_data"])) {
                this.selected_branch_data = [] as any;
                for (let item of _data["selected_branch_data"])
                    this.selected_branch_data!.push(GeoFenceBranchOutput.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GeoFenceOutputWithOutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new GeoFenceOutputWithOutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geofence_id"] = this.geofence_id;
        data["company_type"] = this.company_type;
        data["branch_type"] = this.branch_type;
        data["name"] = this.name;
        data["description"] = this.description;
        data["tolerance"] = this.tolerance;
        data["geofence_data"] = this.geofence_data;
        data["shape_data"] = this.shape_data;
        data["category"] = this.category;
        data["show_geofence"] = this.show_geofence;
        data["consider_for_trip"] = this.consider_for_trip;
        data["fence_type"] = this.fence_type;
        data["company_details_id"] = this.company_details_id;
        data["branch_detail_id"] = this.branch_detail_id;
        data["color"] = this.color;
        if (Array.isArray(this.selected_company_data)) {
            data["selected_company_data"] = [];
            for (let item of this.selected_company_data)
                data["selected_company_data"].push(item.toJSON());
        }
        if (Array.isArray(this.selected_branch_data)) {
            data["selected_branch_data"] = [];
            for (let item of this.selected_branch_data)
                data["selected_branch_data"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface IGeoFenceOutputWithOutStatus {
    /** The auto-generated id of the geofence master */
    geofence_id: number;
    /** The company type should be All or Selected */
    company_type: string;
    /** The branch type should be All or Selected */
    branch_type: string;
    /** The place name with 255 character limit */
    name: string;
    /** The description with 5000 character limit */
    description: string;
    /** The tolerance of selected place */
    tolerance: number;
    /** The geofence data */
    geofence_data: string;
    /** The shapeData data */
    shape_data: string;
    /** Selected category for geofence */
    category: string;
    /** The flag for show geofence */
    show_geofence: number;
    /** The consider for trip */
    consider_for_trip: number;
    /** Fence type */
    fence_type: string;
    /** The auto generated id from company details master */
    company_details_id: number;
    /** The auto generated id from branch details master */
    branch_detail_id: number;
    /** The color with 255 character limit */
    color: string;
    selected_company_data: GeoFenceCompanyOutput[];
    selected_branch_data: GeoFenceBranchOutput[];
    status: number;
}

